import React, { Fragment, useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Container,
  Grid,
  Typography,
  CardHeader,
  Avatar,
  Box,
  Fade
} from "@material-ui/core"
import { withStyles } from "@material-ui/styles"
import styles from "./styles"
import AppCard from "components/AppCard"
import { getPosts } from "actions/posts"
import PostLoading from "components/PostLoading"
import cloudinary from "cloudinary-core"
import noPostsImg from "assets/no-posts-img.svg"
const cl = new cloudinary.Cloudinary({
  cloud_name: process.env.REACT_APP_CLOUD_NAME
})
import InfiniteScroll from "react-infinite-scroll-component"

const Feed = ({
  dispatch,
  classes,
  posts,
  authentication,
  currentOrg,
  isLoading
}) => {
  const [postLoading, setPostLoading] = useState(true)
  // Gets token param if exists
  const urlParams = new URLSearchParams(window.location.search)
  const queryToken = urlParams.get("token")
  const [postsPerPage, setPostsPerPage] = useState([])

  useEffect(() => {
    // Delays get post feed call by 1 sec if token is in URL param.
    // This prevents request being sent before token is set
    if (queryToken !== null) {
      setTimeout(() => {
        // console.log("GET FEED")
        dispatch(getPosts("feed"))
        setPostLoading(false)
      }, 1000)
    } else {
      dispatch(getPosts("feed"))
      setPostLoading(false)
    }
  }, [])

  // useEffect(() => {
  //   console.log(posts.length)
  //   if (!posts.length) {
  //     console.log("GET POSTS AUTH")
  //     dispatch(getPosts("feed"))
  //     setPostLoading(false)
  //   }
  // }, [])

  let newCurrentOrgName = ""
  if (
    currentOrg.name &&
    window.innerWidth <= 540 &&
    currentOrg.name.length > 16
  ) {
    try {
      newCurrentOrgName = currentOrg.name.slice(0, 16) + "..."
    } catch (err) {
      console.log(err)
    }
  } else if (
    currentOrg.name &&
    window.innerWidth <= 720 &&
    currentOrg.name.length > 30
  ) {
    try {
      newCurrentOrgName = currentOrg.name.slice(0, 30) + "..."
    } catch (err) {
      console.log(err)
    }
  } else if (currentOrg.name && currentOrg.name.length > 45) {
    try {
      newCurrentOrgName = currentOrg.name.slice(0, 45) + "..."
    } catch (err) {
      console.log(err)
    }
  } else {
    try {
      newCurrentOrgName = currentOrg.name
    } catch (err) {
      console.log(err)
    }
  }

  const fetchMoreData = () => {
    setPostsPerPage(posts.slice(0, postsPerPage.length + 12))
  }
  useEffect(() => {
    setPostsPerPage(posts.slice(0, 12))
  }, [posts])

  return (
    <Fragment>
      <Container>
        <CardHeader
          className={classes.org}
          avatar={
            <Avatar
              aria-label="recipe"
              varient="rounded"
              src={
                currentOrg.logo &&
                cl.url(JSON.parse(currentOrg.logo).public_id, {
                  width: 150,
                  crop: "scale"
                })
              }
            />
          }
          title={
            <Typography variant="h2" className={classes.orgName}>
              {newCurrentOrgName}
            </Typography>
          }
        />
        <Grid container className={classes.gridContainer}>
          {isLoading || postLoading ? <PostLoading /> : ""}

          {Boolean(postsPerPage.length) &&
            postsPerPage.map(post => (
              <Fragment key={post.id}>
                <InfiniteScroll
                  dataLength={postsPerPage.length}
                  next={fetchMoreData}
                  hasMore="true"
                  // loader={<h4>Loading...</h4>}
                  endMessage={
                    <p style={{ textAlign: "center" }}>
                      <b>Yay! You have seen it all</b>
                    </p>
                  }
                >
                  <AppCard post={post} />
                </InfiniteScroll>
              </Fragment>
            ))}
          {!posts.length && !isLoading && !postLoading && (
            <Fade in timeout={500}>
              <Box
                className={classes.noPostsContainer}
                display="flex"
                justifyContent="center"
                flexDirection="column"
              >
                <img src={noPostsImg} />
                <Typography className={classes.noPostsText} color="primary">
                  No Posts Found
                </Typography>
              </Box>
            </Fade>
          )}
        </Grid>
      </Container>
    </Fragment>
  )
}

const mapStateToProps = state => {
  return {
    data: state.dialogsContainerDialog.data,
    posts: state.posts.data,
    currentOrg: state.organization.currentOrg,
    isLoading: state.posts.isLoading,
    searchFilter: state.posts.searchFilter,
    authentication: state.authentication
  }
}

const connector = connect(mapStateToProps)

export default connector(withStyles(styles)(Feed))



// WEBPACK FOOTER //
// ./src/pages/App/Feed/index.js